import { Component, Input, Output, OnInit, OnChanges, EventEmitter, SimpleChanges, OnDestroy} from '@angular/core';
import { JobServicesService } from 'src/app/services/job-services.service';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { EventServicesService } from 'src/app/services/event-services.service';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { FieldLookupService } from 'src/app/services/field-lookup.service';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import * as codes from '../../../assets/Json/countryTeleCodes.json';
import { MultiSelectFilterEvent } from 'primeng/multiselect';
import { DEADLINE_OPTIONS } from 'src/app/constants/deadline-options';
@Component({
    selector: 'app-workflow-ruleset',
    templateUrl: './workflow-ruleset.component.html',
    styleUrls: ['./workflow-ruleset.component.css'],
    providers: [ConfirmationService, MessageService],
    standalone: false
})
export class WorkflowRulesetComponent implements OnInit, OnChanges, OnDestroy {
  instituteSearch$: Subject<void> = new Subject<void>();

  @Input() stage: any;
  @Input() allStages: any;
  @Input() isTestSelected: any;

  stageTriggerOptions: any = [];
  stageActionOptions: any = [];
  savedWorkflowIds: Array<string> = [];

  sendMailTemplate: any = [];
  specificConditions: any = [];
  ruleActionFormData: {
    jobRolesWithCities: Array<{ id: number; name: string; cities: string[] }>;
    jobRolesList: Array<{ label: string; value: number }>;
    roles: any[];
    eventUsers: Array<{ label: string; value: string }>;
    deadlineList: Array<{ label: string; value: string }>;
  } = {
    jobRolesWithCities: [],
    jobRolesList: [],
    roles: [],
    eventUsers: [],
    deadlineList: DEADLINE_OPTIONS,
  };
  stringBasedOperators: Array<any> = [];
  numberBasedOperators: Array<any> = [];
  multiValueOperators: Array<any> = [];
  booleanBasedOperators: Array<any> = [];
  dateBasedOperators: Array<any> = [];
  triggerFields: Array<any> = [];
  stage_rule_condition: any = [];
  stage_condition_operators: any = [];
  stage_rules: any = [];
  selectedTriggers: any[] = [];
  stage_rule_trigger_options: any = [];
  stage_rule_action_options: any = [];

  stageConditions: string[] = [];
  logicConditions: string[] = [];

  jobId: string = '';
  userPrivileges: Set<string> = new Set();
  eventId: string = '';
  countryCodeList: any = (codes as any).default;

  loadingButton: boolean = false;
  loadActionOptions: boolean = false;
  stageError: boolean = false;
  pageLoading: boolean = false;
  loadConditionOptions: boolean = false;
  dateFormat: any;

  showRuleDialog: boolean = false;
  currentRuleIndex: number = -1;
  ruleDialogTitle: string = 'Add Rule';

  constructor(
    private jobServices: JobServicesService,
    private emailServices: EmailServicesService,
    private eventServices: EventServicesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private globalService: GlobalServicesService,
    private formBuilderServices: FormBuilderService,
    private fieldLookupService: FieldLookupService,
    private activatedRoute: ActivatedRoute, 
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.eventId = params['eventId'] || '';
      if (this.eventId) {
        this.getStageRuleFormData();
        this.getStageRuleList();
      } else {
        console.error('eventId missing in URL');
      }
    });    this.numberBasedOperators = [
      { sign: '==', clause: '==' },
      { sign: '!=', clause: '!=' },
      { sign: '>=', clause: '>=' },
      { sign: '<=', clause: '<=' },
      { sign: '>', clause: '>' },
      { sign: '<', clause: '<' },
    ]
    this.dateBasedOperators = [
      { sign: '==', clause: '==' },
      { sign: '!=', clause: '!=' },
      { sign: '>=', clause: '>=' },
      { sign: '<=', clause: '<=' },
      { sign: '>', clause: '>' },
      { sign: '<', clause: '<' },
    ]

    this.stringBasedOperators = [
      { sign: '==', clause: '==' },
      { sign: '!=', clause: '!=' },
      { sign: 'Starts with', clause: 'starts_with' },
      { sign: 'Ends with', clause: 'ends_with' },
      { sign: 'Contains', clause: 'contains' },
      { sign: 'Not Contains', clause: 'not_contains' },
      { sign: 'Of Length', clause: 'of_length' },
    ]

    this.multiValueOperators = [
      { sign: 'Contains', clause: 'contains' },
      { sign: 'Not Contains', clause: 'not_contains' },
      // { sign: 'Of Length', clause: 'of_length' },
    ]

    this.booleanBasedOperators = [
      { sign: '==', clause: '==' },
      { sign: '!=', clause: '!=' },
    ]
  }
  getEmailTemplate = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      this.emailServices.getTemplatesFastApi('', 'Others').subscribe({
        next: (response) => {
          if (response.status === 200) {
            let templateList = response.body.email_templates ? response.body.email_templates : [];
            this.sendMailTemplate = templateList.map((item: any) => ({
              id: item.id,
              isEditable: item.is_editable,
              name: item.name,
            }));
            resolve();
          }
        },
        error: (err) => {
          reject(new Error('Error fetching email templates: ' + err));
        }
      });
    });
  }

  loadRuleActionFormData = (): void => {
    if (!this.eventId) return;
    this.eventServices.getEventStageActionFormDataFastApi(this.eventId, 'Documentation').subscribe({
      next: (response) => {
        if (response.status === 200 && response.body?.job_roles) {
          const roles: any[] = response.body.job_roles || [];
          this.ruleActionFormData.jobRolesWithCities = roles.map((r: any) => ({
            id: r.id,
            name: r.name,
            cities: r.cities || []
          }));
          this.ruleActionFormData.jobRolesList = roles.map((r: any) => ({ label: r.name, value: r.id }));
        }
        if (response.body?.roles) {
          this.ruleActionFormData.roles = response.body.roles;
        }
        this.refreshAvailableLocationsForRules();
      },
      error: (_err) => { }
    });
  }

  getLocationsForJobRole = (roleId: number | string | null): Array<{ label: string; value: string }> => {
    if (roleId == null) return [];
    const role = this.ruleActionFormData.jobRolesWithCities.find(
      (r: any) => Number(r.id) === Number(roleId)
    );
    return (role?.cities || []).map((city: string) => ({ label: city, value: city }));
  }

  onRuleJobRoleChange = (action: any, roleId: number | string | null): void => {
    if (!action.values?.actionFormDetails) return;
    action.values.actionFormDetails.availableLocations = this.getLocationsForJobRole(roleId);
    action.values.actionFormDetails.job_locations = null;
  }

  refreshAvailableLocationsForRules = (): void => {
    if (!this.stage_rules?.length) return;
    this.stage_rules.forEach((rule: any) => {
      [...(rule.actionsList || []), ...(rule.elseActionsList || [])].forEach((action: any) => {
        if (action.values?.actionName?.name === 'Send Offer Form' && action.values?.actionFormDetails?.job_role_id != null) {
          action.values.actionFormDetails.availableLocations =
            this.getLocationsForJobRole(action.values.actionFormDetails.job_role_id);
        }
      });
    });
  }

  getOwnerDetailsForRule = (roleId: string): void => {
    if (!roleId) return;
    this.jobServices.getUserByRoleIdFastApi(roleId).subscribe({
      next: (response: any) => {
        const raw = response.body?.users;
        const users = Array.isArray(raw) ? raw : (raw ? Object.values(raw) : []);
        this.ruleActionFormData.eventUsers = (users as any[]).map((u: any) => ({
          label: `${u.first_name || ''} ${u.last_name || ''}`.trim(),
          value: u.id
        }));
      },
      error: (_err) => { }
    });
  }
  async ngOnInit() {
    this.pageLoading = true;

    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
  }

  ngOnDestroy(): void {
    this.instituteSearch$.next();
    this.instituteSearch$.complete();
  }

  async getStageRuleFormData(): Promise<void> {
    if (!this.stage || !this.stage.id) {
      return Promise.resolve();
    }
    return new Promise(async (resolve, reject) => {
      this.jobServices.getStageRuleFormDataFastApi(this.stage.id, this.eventId).subscribe({
        next: async (result: any) => {
          this.stageTriggerOptions = result?.body ? result.body?.triggers : [];
          this.stage_rule_condition = result?.body ? result.body?.condition_types : [];
          this.stage_condition_operators = result?.body ? result.body?.condition_operators : [];
          this.stage_rule_action_options = result?.body ? result.body?.actions : [];  
          this.loadRuleActionFormData();
          const originalDropdowns = result?.body ? result.body?.dropdown_values : {};  
          const sharedService = this.globalService.getSharedService();
          
          try {
            const formFields = originalDropdowns?.registration_form_fields || [];
            const lookupData = await this.fieldLookupService.loadOptimizedLookupData(this.eventId, formFields);
            
            const institutes = lookupData.institutes.items || [];
            const roles = lookupData.roles || [];
            let preferredLocations = [];

            if (roles && roles.length > 0 && roles[0].preferred_location) {
              preferredLocations = roles[0].preferred_location;
            }  
            const newDropdowns = JSON.parse(JSON.stringify(originalDropdowns));  
            const appendToFieldOptions = (field: any, newOptions: any[]) => {
              if (!newOptions || newOptions.length === 0) return;
              
              const existingOptions = field.field_options || [];
              const existingValues = field.field_value || [];              
              const uniqueNewOptions = newOptions.filter((newOption: any) => 
                !existingOptions.some((existing: any) => existing.value === newOption.value)
              );
              
              if (uniqueNewOptions.length > 0) {
                field.field_options = [...existingOptions, ...uniqueNewOptions];
                field.field_value = [...existingValues, ...uniqueNewOptions];
              }
            };
            
            if (institutes && institutes.length > 0) {
              for (const formType in newDropdowns) {
                for (let i = 0; i < newDropdowns[formType].length; i++) {
                  const field = newDropdowns[formType][i];                    
                  if (field.field_name === 'ug_college_name'||field.field_name === 'pg_college_name'||field.field_name === 'diploma_college_name') {
                    field.field_type = 'Dropdown';
                    const newValues = institutes.map((institute: any) => ({
                      label: `${institute.name}, ${institute.city}, ${institute.state}`,
                      value: `${institute.name}, ${institute.city}, ${institute.state}`,
                    }));
                    
                    appendToFieldOptions(field, newValues);
                  }
                }
              }
            }
            // lookupData is already available from the optimized method

            for (const formType in newDropdowns) {
              for (let i = 0; i < newDropdowns[formType].length; i++) {
                const field = newDropdowns[formType][i];
                const fieldName = field.field_name;
                
                if (fieldName === 'certifications' && field.field_type === 'Dropdown' && (!field.field_options || field.field_options.length === 0)) {
                  const certValues = lookupData.certifications.map((cert: any) => ({
                    label: cert.name,
                    value: cert.name,
                  }));
                  appendToFieldOptions(field, certValues);
                }
                
                if (fieldName === 'known_languages' && field.field_type === 'Dropdown' && (!field.field_options || field.field_options.length === 0)) {
                  const langValues = lookupData.languages.map((lang: any) => ({
                    label: lang.name,
                    value: lang.name,
                  }));
                  appendToFieldOptions(field, langValues);
                }
                
                
                if (fieldName === 'class10_board_name' || fieldName === 'class10_board_type') {
                  field.field_type = 'Dropdown';
                  const sscValues = lookupData.ssc_boards.map((board: any) => ({
                    label: board.name,
                    value: board.name,
                  }));
                  appendToFieldOptions(field, sscValues);
                }
                
                if (fieldName === 'class12_board_name' || fieldName === 'class12_board_type') {
                  field.field_type = 'Dropdown';
                  const interValues = lookupData.intermediate_boards.map((board: any) => ({
                    label: board.name,
                    value: board.name,
                  }));
                  appendToFieldOptions(field, interValues);
                }
                
                if (['ug_degree', 'pg_degree', 'diploma_degree'].includes(fieldName)) {
                  field.field_type = 'Dropdown';
                  const degreeValues = (lookupData.education_degrees || [])
                    .filter((degree: any) => String(degree?.name ?? '').toLowerCase() !== 'others')
                    .map((degree: any) => ({
                      label: degree.name,
                      value: degree.name,
                    }));
                  appendToFieldOptions(field, degreeValues);
                }
                
                if (['ug_specialization', 'pg_specialization', 'diploma_specialization'].includes(fieldName)) {
                  field.field_type = 'Dropdown';
                  const branchValues = (lookupData.education_branches || [])
                    .filter((branch: any) => String(branch?.name ?? '').toLowerCase() !== 'others')
                    .map((branch: any) => ({
                      label: branch.name,
                      value: branch.name,
                    }));
                  appendToFieldOptions(field, branchValues);
                }
                
                if (fieldName === 'entrance_test' && field.field_type === 'Dropdown' && (!field.field_options || field.field_options.length === 0)) {
                  const testValues = lookupData.entrance_tests.map((test: any) => ({
                    label: test.name,
                    value: test.name,
                  }));
                  appendToFieldOptions(field, testValues);
                }
              }
            }  
            if (roles && roles.length > 0) {
              for (const formType in newDropdowns) {
                for (let i = 0; i < newDropdowns[formType].length; i++) {
                  const field = newDropdowns[formType][i];
                  
                  if (field.field_name === 'preferred_role') {
                    // Ensure field type is set to dropdown for role fields
                    field.field_type = 'Dropdown';
                    const newValues = roles.map((role: any) => ({
                      label: role.job_role_name,
                      value: role.job_role_id.toString(),
                    }));
                    appendToFieldOptions(field, newValues);
                  }
                }
              }
            }  
            if (preferredLocations && preferredLocations.length > 0) {
              for (const formType in newDropdowns) {
                for (let i = 0; i < newDropdowns[formType].length; i++) {
                  const field = newDropdowns[formType][i];
                  
                  if (field.field_name === 'preferred_location_1' || field.field_name === 'preferred_location_2' || field.field_name === 'preferred_location_3') {
                    field.field_type = 'Dropdown';
                    const newValues = preferredLocations.map((location: string, index: number) => ({
                      label: location,
                      value: (index + 1).toString(),
                    }));

                    appendToFieldOptions(field, newValues);
                  }
                }
              }
            }  

            this.stage_rule_trigger_options = JSON.parse(JSON.stringify(newDropdowns));            
            this.fieldLookupService.setFormFieldOptions(this.eventId, newDropdowns);
            this.pageLoading = false;
            resolve();
          } catch (error) {
            console.error('Error fetching form details:', error);
            const filteredDropdowns: any = {};
            for (const formType in originalDropdowns) {         
              filteredDropdowns[formType] = originalDropdowns[formType].filter((field: any) => field.field_type !== 'File' && field.field_type !== 'Multi-file');
            }
            this.stage_rule_trigger_options = filteredDropdowns;            
            this.fieldLookupService.setFormFieldOptions(this.eventId, filteredDropdowns);
            this.pageLoading = false;
            resolve();
          }
        },
        error: () => {
          this.pageLoading = false;
          reject(new Error('Error fetching stage rule form data'));
        }
      });
    });
  }
  async ngOnChanges(changes: SimpleChanges) {
    if(changes['stage']){
      await this.getEmailTemplate();
      if(this.userPrivileges.has('event_stage_rule.update') || this.userPrivileges.has('event_stage_rule.create')){
      await this.getStageRuleFormData();
      }
      if(this.userPrivileges.has('event_stage_rule.view')){
        await this.getStageRuleList();
      }
    }
  }
  getStageRuleList(): Promise<void> {
    if (!this.stage || !this.stage.id) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      this.pageLoading = true;
      this.jobServices.getAllRulesFastApi(this.stage.id, this.eventId).subscribe({
        next: (result: any) => {
          if (result.status === 200) {
            const stageRules = result.body || [];
            
            if (stageRules.length > 0) {
              this.savedWorkflowIds = stageRules.map((rule: any) => rule.id);
              Promise.all(stageRules.map((apiRule: any) => this.mapApiRuleToStageRule(apiRule))).then(mappedRules => {
                this.stage_rules = mappedRules;
                resolve();
              });
            } else {
              this.stage_rules = [];
              resolve();
            }
            this.pageLoading = false;
          } else {
            this.pageLoading = false;
            reject(new Error('Failed to fetch rules'));
          }
        },
        error: (error) => {
          this.pageLoading = false;
          console.error('Error in fetching rules', error);
          reject(new Error('Error in fetching rules'));
        }
      });
    });
  }
  async mapApiRuleToStageRule(apiRule: any): Promise<any> {
    // Map the trigger
    const trigger = this.stageTriggerOptions.find((option: any) => option.id === apiRule.trigger.id) || {
      id: apiRule.trigger.id,
      name: apiRule.trigger.value,
      form_type: ''
    };
  
    // Map the stage condition
    const stageCondition = this.stage_rule_condition.find((condition: any) => condition.id === apiRule.applicable.id) || {
      id: apiRule.applicable.id,
      name: apiRule.applicable.value
    };
    // Initialize specificConditions for this rule
    this.specificConditions = [];
    const triggerFormType = trigger.form_type || '';
    this.triggerFields = this.stage_rule_trigger_options[triggerFormType] || [];
    this.triggerFields.forEach((field: any) => {
      this.specificConditions.push({
        name: field.field_label,
        label: field.field_name,
        inputType: field.field_type, 
        options: field?.field_options ? field.field_options : []
      });
    });

    // Initialize variables
    let conditionsList = [];
    let elseActionsList = [];
    let logicCondition = this.stage_condition_operators.find((operator: any) => operator.name === "All");
    let logicOperator = [];
  
    if (stageCondition.name === 'For All') {
      // Set default empty values when stageCondition is "For All"
      conditionsList = [{
        specific: this.specificConditions,
        operator: [],
        values: {
          conditionSource: { name: '', label:'', inputType: '', options: [] },
          conditionClause: '',
          conditionValue: { value: '', type: '' },
        }
      }];
  
      elseActionsList = [{
        actions: this.stage_rule_action_options,
        template: [],
        values: {
          actionName: '',
          actionTemplate: '',
          actionTemplateContent: '',
          actionFormDetails: {},
        }
      }];
  
      logicOperator = [];
    } else {
      // Map the logic condition
      logicCondition = this.stage_condition_operators.find((operator: any) => operator.id === apiRule.conditions[0]?.operator.id) || {
        id: apiRule.conditions[0]?.operator.id,
        name: apiRule.conditions[0]?.operator.value
      };
      // Map the conditions list
      conditionsList = (apiRule.conditions[0]?.rules || []).map((rule: any) => {
        const conditionSourceDetails = this.getConditionSourceDetails(rule.property);
        const conditionClause = this.getOperatorsForInputType(conditionSourceDetails.inputType).find((clause: any) => clause.clause === rule.condition) || {
          clause: rule.condition,
          sign: rule.condition
        };
        return {
          specific: this.specificConditions,
          operator: this.getOperatorsForInputType(conditionSourceDetails.inputType),
          values: {
            conditionSource: {
              name: conditionSourceDetails.name,
              label: rule.property,
              inputType: conditionSourceDetails.inputType,
              options: conditionSourceDetails.options
            },
            conditionClause: conditionClause,
            conditionValue: {
              value: rule.value,
              type: conditionSourceDetails.inputType
            }
          }
        };
      });
  
      // Map the else actions list
      elseActionsList = await Promise.all(
        (apiRule.actions.negative || []).map(async (actionItem: any) => {
          const actionName = this.stage_rule_action_options.find(
            (actionOption: any) => actionOption.id === actionItem.action.id
          ) || {
            id: actionItem.action.id,
            name: actionItem.action.value
          };
          const actionTemplate = this.getActionTemplate(actionItem);
          const actionTemplateContent = actionName.name === 'Send Test Link' ? '' : await this.getActionSpecificTemplateData(actionItem);
  
          let template: any[] = [];
          if (actionName.name === 'Send Email') {
            template = this.sendMailTemplate;
          } else if (actionName.name === 'Send Test Link') {
            template = [];
          } else if (actionName.name === 'Send Document Form' || actionName.name === 'Send Offer Form') {
            template = [];
          } else if (actionName.name === 'Move Candidate To Stage') {
            template = this.allStages.filter((stage: any) => stage.id !== this.stage.id);
          }
        const actionFormDetails: any = {};
        if (actionName.name === 'Send Document Form' || actionName.name === 'Send Offer Form') {
          actionFormDetails.job_role_id = actionItem.job_role_id ?? null;
          actionFormDetails.job_locations = actionItem.job_locations ?? null;
          actionFormDetails.submission_deadline = actionItem.submission_deadline ?? null;
          if (actionName.name === 'Send Offer Form') {
            actionFormDetails.availableLocations = this.getLocationsForJobRole(actionFormDetails.job_role_id);
          }
          if (actionName.name === 'Send Document Form') {
            actionFormDetails.documentation_poc_id = actionItem.documentation_poc_id ?? null;
            actionFormDetails.documentation_poc_role = actionItem.documentation_poc_role ?? null;
            actionFormDetails.documentation_poc_username = actionItem.documentation_poc_username ?? null;
          }
        }
          return {
            actions: this.stage_rule_action_options,
            template: template,
            values: {
              actionName: actionName,
              actionTemplate: actionTemplate,
              actionTemplateContent: actionTemplateContent,
              actionFormDetails: actionFormDetails,
            }
          };
        })
      );
  
      // Populate logicOperator
      if (conditionsList.length > 1) {
        for (let i = 0; i < conditionsList.length - 1; i++) {
          logicOperator.push(logicCondition.name);
        }
      }
    }
  
    // Map the actions list
    const actionsList = await Promise.all(
      (apiRule.actions.positive || []).map(async (actionItem: any) => {
        const actionName = this.stage_rule_action_options.find(
          (actionOption: any) => actionOption.id === actionItem.action.id
        ) || {
          id: actionItem.action.id,
          name: actionItem.action.value
        };
        const actionTemplate = this.getActionTemplate(actionItem);
        const actionTemplateContent = actionName.name === 'Send Test Link' ? '' : await this.getActionSpecificTemplateData(actionItem);
  
        let template: any[] = [];
        if (actionName.name === 'Send Email') {
          template = this.sendMailTemplate;
        } else if (actionName.name === 'Send Test Link') {
          template = [];
        } else if (actionName.name === 'Send Document Form' || actionName.name === 'Send Offer Form') {
          template = [];
        } else if (actionName.name === 'Move Candidate To Stage') {
          template = this.allStages.filter((stage: any) => stage.id !== this.stage.id);
        }
        const actionFormDetails: any = {};
        if (actionName.name === 'Send Document Form' || actionName.name === 'Send Offer Form') {
          actionFormDetails.job_role_id = actionItem.job_role_id ?? null;
          actionFormDetails.job_locations = actionItem.job_locations ?? null;
          actionFormDetails.submission_deadline = actionItem.submission_deadline ?? null;
          if (actionName.name === 'Send Offer Form') {
            actionFormDetails.availableLocations = this.getLocationsForJobRole(actionFormDetails.job_role_id);
          }
          if (actionName.name === 'Send Document Form') {
            actionFormDetails.documentation_poc_id = actionItem.documentation_poc_id ?? null;
            actionFormDetails.documentation_poc_role = actionItem.documentation_poc_role ?? null;
            actionFormDetails.documentation_poc_username = actionItem.documentation_poc_username ?? null;
          }
        }
        return {
          actions: this.stage_rule_action_options,
          template: template,
          values: {
            actionName: actionName,
            actionTemplate: actionTemplate,
            actionTemplateContent: actionTemplateContent,
            actionFormDetails: actionFormDetails,
          }
        };
      })
    );
  
    // Construct the new rule object
    return {
      id: apiRule.id,
      isShowSummary: true,
      stageId: apiRule.stage_uuid,
      trigger: trigger,
      conditionsList: conditionsList,
      stageCondition: stageCondition,
      logicCondition: logicCondition,
      logicOperator: logicOperator,
      displayAction: true,
      displayElseAction: false,
      actionsList: actionsList,
      elseActionsList: elseActionsList
    };
  }
  
  
  getConditionSourceDetails(propertyName: string): any {
    // Find the field in your triggerFields or stage_rule_trigger_options
    let field = null;
    for (const key in this.stage_rule_trigger_options) {
      const fields = this.stage_rule_trigger_options[key];
      field = fields.find((f: any) => f.field_name === propertyName);
      if (field) break;
    }
    if (field) {
      let fieldOptions = field.field_options || [];
      if ((field.field_type === 'country_code' || field.field_type === 'Dropdown') && 
          (field.field_name === 'country_code' || field.field_name === 'secondary_num_country_code') && 
          (!fieldOptions || fieldOptions.length === 0)) {
        fieldOptions = this.countryCodeList.map((country: any) => ({
          label: `${country.country} (+${country.countryCodes[0]})`,
          value: country.countryCodes[0]
        }));
      }
      
      return {
        name: field.field_label,
        inputType: field.field_type, 
        options: fieldOptions
      };
    }
    return {
      name: '',
      inputType: '',
      options: []
    };
  }
  getActionTemplate(actionItem: any): any {
    if (actionItem.email_template_id) {
      const template = this.sendMailTemplate.find((t: any) => t.id === actionItem.email_template_id);
      return template || { id: actionItem.email_template_id, name: 'Unknown Template' };
    } else if (actionItem.move_stage_uuid) {
      const stage = this.allStages.find((s: any) => s.id === actionItem.move_stage_uuid);
      return stage || { id: actionItem.move_stage_uuid, name: 'Unknown Stage' };
    }
    return null;
  }
  getActionSpecificTemplateData(actionItem: any): Promise<string> {
    return new Promise((resolve, reject) => {
      if (actionItem.email_template_id) {
        this.emailServices.getSpecificTemplateFastApi(actionItem.email_template_id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              resolve(response.body.body);
            } else {
              resolve('');
            }
          },
          error: (err) => {
            console.error('Error fetching specific template: ' + err);
            resolve('');
          }
        });
      } else {
        resolve('');
      }
    });
  }
  
  getOperatorsForInputType(inputType: string): any {
    switch(inputType) {
      case 'Input':
      case 'Email':
      case 'Mobile':
      case 'Textarea':
      case 'File':
        return this.stringBasedOperators;
      
      case 'Number':
      case 'Percentage':
        return this.numberBasedOperators;
      
      case 'Multi-dropdown':
      case 'Checkbox':
        return this.multiValueOperators;
      
      case 'Dropdown':
      case 'Radio':
        return this.booleanBasedOperators;
      
      case 'Date Picker':
        return this.dateBasedOperators;
      
      default:
        return this.stringBasedOperators;
    }
  }
  getTriggers = (trigger: any, rule_index?: any) => {
    this.specificConditions = [];
    this.loadConditionOptions = true;
    this.triggerFields = this.stage_rule_trigger_options[trigger.form_type];
    this.triggerFields.forEach((field: any) => {
      let fieldOptions = field?.field_options ? field.field_options : [];
      if ((field.field_type === 'country_code' || field.field_type === 'Dropdown') && 
          (field.field_name === 'country_code' || field.field_name === 'secondary_num_country_code') && 
          (!fieldOptions || fieldOptions.length === 0)) {
        fieldOptions = this.countryCodeList.map((country: any) => ({
          label: `${country.country} (+${country.countryCodes[0]})`,
          value: country.countryCodes[0]
        }));
      }
      
      if(!["multi-file", "file"].includes(field.field_type?.toLowerCase())) {
        this.specificConditions.push({ 
          name: field.field_label, 
          label: field.field_name, 
          inputType: field.field_type, 
          options: fieldOptions 
        });
      }
    })
    this.stage_rules[rule_index].conditionsList[0].specific = this.specificConditions;
    this.loadConditionOptions = false;
  }

  getJobRoleLabel = (jobRoleId: any): string => {
    if (!jobRoleId) return '-';
    const found = this.ruleActionFormData.jobRolesList.find(
      (r: any) => String(r.value) === String(jobRoleId)
    );
    return found?.label || String(jobRoleId);
  }

  getLocationsLabel = (locations: any): string => {
    if (!locations) return '-';
    if (Array.isArray(locations)) {
      return locations.join(', ');
    }
    return String(locations);
  }
  
  getAvailableActions = (actionsList: any[], isElseAction: boolean = false): any[] => {
    const selectedActionIds = actionsList
      .filter((action: any) => action.values?.actionName?.id)
      .map((action: any) => action.values.actionName.id);
    return this.stage_rule_action_options.filter(
      (option: any) => !selectedActionIds.includes(option.id)
    );
  }
  getAvailableActionsForRow = (actionsList: any[], currentAction: any): any[] => {
    const selectedByOthers = actionsList
      .filter((a: any) => a !== currentAction && a.values?.actionName?.id)
      .map((a: any) => a.values.actionName.id);
    return this.stage_rule_action_options.filter(
      (option: any) => !selectedByOthers.includes(option.id)
    );
  }

  refreshAllActionDropdowns = (actionsList: any[]) => {
    actionsList.forEach((action: any) => {
      action.actions = this.getAvailableActionsForRow(actionsList, action);
    });
  }

  addNewAction = (stage_rule_action_list: any) => {
    const availableActions = this.getAvailableActions(stage_rule_action_list);
    stage_rule_action_list.push({
      actions: availableActions, template: [], values: {
        actionName: '',
        actionTemplate: '',
        actionTemplateContent: '',
        actionFormDetails: {},
      }
    });
    this.refreshAllActionDropdowns(stage_rule_action_list);
  }

  addNewElseAction = (stage_rule_else_action_list: any) => {
    const availableActions = this.getAvailableActions(stage_rule_else_action_list);
    stage_rule_else_action_list.push({
      actions: availableActions, template: [], values: {
        actionName: '',
        actionTemplate: '',
        actionTemplateContent: '',
        actionFormDetails: {},
      }
    });
    this.refreshAllActionDropdowns(stage_rule_else_action_list);
  }

  onActionSelected = (event: any, actionIndex: number, actionsList: any[]) => {
    this.refreshAllActionDropdowns(actionsList);
  }

  removeAction = (action: any, rule_index: number) => {
    this.stage_rules[rule_index].actionsList = this.stage_rules[rule_index].actionsList.filter((val: any) => val !== action);
    this.refreshAllActionDropdowns(this.stage_rules[rule_index].actionsList);
  }

  removeElseAction = (action: any, rule_index: number) => {
    this.stage_rules[rule_index].elseActionsList = this.stage_rules[rule_index].elseActionsList.filter((val: any) => val !== action);
    this.refreshAllActionDropdowns(this.stage_rules[rule_index].elseActionsList);
  }

  addCondition = (condition: any, rule_index: number) => {
    // Ensure conditionsList and logicOperator exist for the specific stage_rule
    if (!this.stage_rules[rule_index].conditionsList) {
      this.stage_rules[rule_index].conditionsList = [];
    }
    
    if (!this.stage_rules[rule_index].logicOperator) {
      this.stage_rules[rule_index].logicOperator = [];
    }
    
    const index = this.stage_rules[rule_index].conditionsList.indexOf(condition);
    // Add a new condition after the current one
    this.stage_rules[rule_index].conditionsList.splice(index + 1, 0, {
      specific: this.specificConditions,
      operator: [],
      values: {
        conditionSource: { name: '',label:'', inputType: '', options: [] },
        conditionClause: '',
        conditionValue: { value: '', type: '' },
      }
    });
    
    // Add a corresponding logic operator
    this.stage_rules[rule_index].logicOperator.splice(index + 1, 0, '');
  }


  removeCondition = (condition: any, rule_index: number) => {
    // Ensure conditionsList exists and has more than one condition
    if (!this.stage_rules[rule_index].conditionsList || this.stage_rules[rule_index].conditionsList.length <= 1) {
      return;  // Do not allow removal if it's the last condition
    }

    const index = this.stage_rules[rule_index].conditionsList.indexOf(condition);

    // Remove the condition from conditionsList
    this.stage_rules[rule_index].conditionsList.splice(index, 1);

    // Remove the corresponding logic operator
    if (this.stage_rules[rule_index].logicOperator) {
      this.stage_rules[rule_index].logicOperator.splice(index - 1, 1);
    }
  }



  clearRuleSet = (rule: any) => {
    rule.trigger = { name: '', id: '', form_type: '' };
    rule.conditionsList = [{
      specific: this.specificConditions, operator: [],
      values: {
        conditionSource: { name: '', inputType: '', options: [] },
        conditionClause: '',
        conditionValue: { value: '', type: '' },
      }
    }];
    rule.stageCondition = this.stage_rule_condition.find((condition: any) => condition.name === 'For All');
    rule.logicCondition = this.stage_condition_operators.find((operator: any) => operator.name === 'All');
    rule.logicOperator = [];
    rule.displayAction = true;
    rule.displayElseAction = false;
    rule.actionsList = [{
      actions: [...this.stage_rule_action_options], template: [], values: {
        actionName: '',
        actionTemplate: '',
        actionTemplateContent: '',
        actionFormDetails: {},
      }
    }];
    rule.elseActionsList = [{
      actions: [...this.stage_rule_action_options], template: [], values: {
        actionName: '',
        actionTemplate: '',
        actionTemplateContent: '',
        actionFormDetails: {},
      }
    }];
  };
  

  selectOperatorOptions = (event: any, condition: any) => {
    const inputType = event.value.inputType;
    const fieldName = event.value.label;
    
    if (fieldName === 'mark_percentage') {
      condition.operator = this.numberBasedOperators;
      return;
    }
    
    if (fieldName === 'notice_period_duration' || inputType === 'Number') {
      condition.operator = this.numberBasedOperators;
      return;
    }
    
    condition.operator = this.getOperatorsForInputType(inputType);

    condition.values.conditionValue.value = ""
    condition.values.conditionClause = null
  }

  selectTemplateOptions = (actionEventId: any, action: any, actionIndex: number, actionsList: any[]) => {
    action.values.actionTemplateContent = '';
    action.values.actionTemplate = '';
    action.values.actionFormDetails = action.values.actionFormDetails || {};
    switch (actionEventId) {
      case "Move Candidate To Stage": {
        this.stageError = !this.allStages.length;
        this.allStages = this.allStages.filter((stage: any) => stage.stageId !== this.stage.stageId);
        action.template = this.allStages;
        break;
      }
      case "Send Email": action.template = this.sendMailTemplate; break;
      case "Send Test Link":
        action.template = [];
        break;
      case "Send Document Form":
        action.template = [];
        action.values.actionFormDetails = { job_role_id: null, job_locations: null, documentation_poc_id: null, documentation_poc_role_id: null, submission_deadline: null };
        break;
      case "Send Offer Form":
        action.template = [];
        action.values.actionFormDetails = { job_role_id: null, job_locations: null, submission_deadline: null, availableLocations: [] };
        break;
      default: action.template = [];
    }
    this.onActionSelected(actionEventId, actionIndex, actionsList);
  }

  setActionValues = async (event: any, action: any) => {
    if (action.actionName?.name === 'Send Email') {
      await this.getSpecificTemplateData(event, action);
    }
  }

  onDocumentPOCRoleChange = (roleId: string, action: any): void => {
    this.ruleActionFormData.eventUsers = [];
    if (!action.values.actionFormDetails) action.values.actionFormDetails = {};
    action.values.actionFormDetails.documentation_poc_id = null;
    if (roleId) {
      this.getOwnerDetailsForRule(String(roleId));
    }
  }
 
  async getSpecificTemplateData(template: any,action:any): Promise<void> {
    if (template.id) {
      return new Promise((resolve, reject) => {
        this.emailServices.getSpecificTemplateFastApi(template.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              action.actionTemplateContent = response.body.body;
              resolve(response.body.body);
            }
          },
          error: (err) => {
            reject(new Error('Error fetching specific template: ' + err));
          }
        });
      });
    }
  }


  removeRule = (workflowId: string,event: any, rule_index?: any) => {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (this.savedWorkflowIds.includes(workflowId)) {
          this.pageLoading = true;
          this.jobServices.deleteRuleFastApi(workflowId,this.stage.id,this.eventId).subscribe({
            next: (result: any) => {
              if(result.status === 200){
                this.pageLoading = false;
                if (result.body) {
                  this.stage_rules = this.stage_rules.filter((rule: any) => rule.id !== workflowId);
                  this.messageService.add({ severity: 'info', summary: 'Deleted', detail: result.body.detail });
                  this.getStageRuleList();
                }
              }
            },
            error: () => {
              this.pageLoading = false;
            }
          })
        } else{
          if(rule_index !== undefined)
          this.stage_rules = this.stage_rules.filter((_rule: any,index: any) => index !== rule_index);
        }
      },
      reject: () => { }
    });
  }
  
  onDateSelect(event: Date, condition: any) {
    const year = event.getFullYear();
    const month = String(event.getMonth() + 1).padStart(2, '0');
    const day = String(event.getDate()).padStart(2, '0');
    condition.values.conditionValue.value = `${year}-${month}-${day}`;
  }

  generateWorkflowPayload(rule_index:any) {
    const stageRule = this.stage_rules[rule_index];
  
    // Map logicCondition to operator code    
    const operatorMapping: any = this.stage_condition_operators.reduce((acc: any, operator: any) => {
      acc[operator.name] = operator.id;
      return acc;
    }, {});

    const payload:any = {
      trigger: stageRule.trigger.id,
      applicable: stageRule.stageCondition.id,
      conditions: [],
      actions: {
        positive: [],
        negative: []
      }
    };
    if (stageRule.stageCondition.name === 'Matching Condition') {
      // Map conditions
      const conditions: any = {
        operator: operatorMapping[stageRule.logicCondition.name] || 10,
        rules: []
      };

      stageRule.conditionsList.forEach((conditionItem: any) => {
        const rule = {
          property: conditionItem.values.conditionSource?.label || '',
          condition: conditionItem.values.conditionClause?.clause || '',
          value: conditionItem.values.conditionValue?.value || ''
        };
        conditions.rules.push(rule);
      });

      payload.conditions.push(conditions);
    }
    // Map positive actions from actionsList
    stageRule.actionsList.forEach((actionItem:any) => {
      const actionData = actionItem.values;
      const action: any = {
        action: actionData.actionName.id
      };
  
      if (actionData.actionName?.name === 'Send Email' && actionData.actionTemplate?.id) {
        action['email_template_id'] = actionData.actionTemplate.id;
      }
      if (actionData.actionName?.name === 'Move Candidate To Stage' && actionData.actionTemplate?.uuid) {
        action['move_stage_uuid'] = actionData.actionTemplate.uuid;
      }
      const formDetails = actionData.actionFormDetails || {};
      if (actionData.actionName?.name === 'Send Document Form') {
        action['job_role_id'] = formDetails.job_role_id ?? null;
        action['job_locations'] = formDetails.job_locations ?? null;
        action['documentation_poc_id'] = formDetails.documentation_poc_id ?? null;
        action['submission_deadline'] = formDetails.submission_deadline ?? null;
      } else if (actionData.actionName?.name === 'Send Offer Form') {
        action['job_role_id'] = formDetails.job_role_id ?? null;
        action['job_locations'] = formDetails.job_locations ?? null;
        action['submission_deadline'] = formDetails.submission_deadline ?? null;
      }
  
      payload.actions.positive.push(action);
    });
    if (stageRule.stageCondition.name === 'Matching Condition') {
      // Map negative actions from elseActionsList
      stageRule.elseActionsList.forEach((actionItem: any) => {
        const actionData = actionItem.values;
        const action: any = {
          action: actionData.actionName.id
        };

        if (actionData.actionName?.name === 'Send Email' && actionData.actionTemplate?.id) {
          action['email_template_id'] = actionData.actionTemplate.id;
        }
        if (actionData.actionName?.name === 'Move Candidate To Stage' && actionData.actionTemplate?.uuid) {
          action['move_stage_uuid'] = actionData.actionTemplate.uuid;
        }
        const formDetails = actionData.actionFormDetails || {};
        if (actionData.actionName?.name === 'Send Document Form') {
          action['job_role_id'] = formDetails.job_role_id ?? null;
          action['job_locations'] = formDetails.job_locations ?? null;
          action['documentation_poc_id'] = formDetails.documentation_poc_id ?? null;
          action['submission_deadline'] = formDetails.submission_deadline ?? null;
        } else if (actionData.actionName?.name === 'Send Offer Form') {
          action['job_role_id'] = formDetails.job_role_id ?? null;
          action['job_locations'] = formDetails.job_locations ?? null;
          action['submission_deadline'] = formDetails.submission_deadline ?? null;
        }

        payload.actions.negative.push(action);
      });
    }else{
      payload.actions.negative = [];
    }
    return payload;
  
  }
  

  async saveWorkflow(workFlowId:any,rule_index: any) {
    this.loadingButton = true;
    const payload = this.generateWorkflowPayload(rule_index);
    if (this.savedWorkflowIds.includes(workFlowId)) {
      this.jobServices.updateRuleFastApi(workFlowId, this.stage.id, this.eventId, payload).subscribe({
        next: (response) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.showRuleDialog = false;
          this.currentRuleIndex = -1;
          this.getStageRuleList();
          this.loadingButton = false;
        },
        error: () => {
          this.loadingButton = false;
        }
      })
    } else {
      this.jobServices.saveRuleFastApi(this.stage.id, this.eventId, payload).subscribe({
        next: (res: any) => {
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: res.body.detail,
          });
          this.showRuleDialog = false;
          this.currentRuleIndex = -1;
          this.getStageRuleList();
          this.loadingButton = false;
        },
        error: () => {
          this.loadingButton = false;
        }
      })
    }
  }

  checkValidation = (stage_rule: any) => {
    let inValid: boolean = false;
    // Validate trigger
    if (!stage_rule.trigger.name) {
      inValid = true;
    }

    // Validate stage condition
    if (!stage_rule.stageCondition.name) {
      inValid = true;
    }

    // Validate conditions if stageCondition is 'Matching Condition'
    if (stage_rule.stageCondition.name === 'Matching Condition') {
      if (stage_rule.conditionsList.length === 0) {
        inValid = true;
      } else {
        stage_rule.conditionsList.forEach((condition: any) => {
          if (
            !condition.values.conditionSource?.name ||
            !condition.values.conditionClause?.clause ||
            !condition.values.conditionValue?.value
          ) {
            inValid = true;
          }
          
          if (condition.values.conditionSource?.label === 'mark_percentage') {
            const percentageValue = parseFloat(condition.values.conditionValue?.value);
            if (isNaN(percentageValue) || percentageValue < 0 || percentageValue >= 100) {
              inValid = true;
            }
          }
          
          // Validate notice period fields accept only numbers
          if (condition.values.conditionSource?.label === 'notice_period_duration') {
            const numericValue = parseFloat(condition.values.conditionValue?.value);
            if (isNaN(numericValue) || numericValue < 0) {
              inValid = true;
            }
          }
        });
      }
      // Validate logic condition
      if (!stage_rule.logicCondition.name) {
        inValid = true;
      }
    }

    // Validate positive actions
    if (stage_rule.actionsList.length === 0) {
      inValid = true;
    } else {
      stage_rule.actionsList.forEach((action: any) => {
        if (!action.values.actionName?.name) {
          inValid = true;
        } else if (action.values.actionName.name !== 'Send Test Link' && action.values.actionName.name !== 'Send Document Form' && action.values.actionName.name !== 'Send Offer Form' && action.template.length > 0 && !action.values.actionTemplate) {
          inValid = true;
        } else if (action.values.actionName.name === 'Send Document Form') {
          const fd = action.values.actionFormDetails || {};
          if (!fd.job_role_id || !fd.documentation_poc_id || !fd.submission_deadline) inValid = true;
        } else if (action.values.actionName.name === 'Send Offer Form') {
          const fd = action.values.actionFormDetails || {};
          if (!fd.job_role_id || !fd.job_locations?.length || !fd.submission_deadline) inValid = true;
        }
      });
    }

    // Validate negative actions if they exist
    if (stage_rule.stageCondition.name === 'Matching Condition') {
      stage_rule.elseActionsList.forEach((action: any) => {
        if (!action.values.actionName?.name) {
          inValid = true;
        } else if (action.values.actionName.name !== 'Send Test Link' && action.values.actionName.name !== 'Send Document Form' && action.values.actionName.name !== 'Send Offer Form' && action.template.length > 0 && !action.values.actionTemplate) {
          inValid = true;
        } else if (action.values.actionName.name === 'Send Document Form') {
          const fd = action.values.actionFormDetails || {};
          if (!fd.job_role_id || !fd.documentation_poc_id || !fd.submission_deadline) inValid = true;
        } else if (action.values.actionName.name === 'Send Offer Form') {
          const fd = action.values.actionFormDetails || {};
          if (!fd.job_role_id || !fd.job_locations?.length || !fd.submission_deadline) inValid = true;
        }
      });
    }

    return inValid;
  };
  

  addRule = (stage: any) => {
    const newRule = {
      id: null,
      stageId: stage.id,
      isShowSummary: false,
      trigger: { name: '', id: '', form_type: '' },
      conditionsList: [{
        specific: [],
        operator: [],
        values: {
          conditionSource: { name: '', label:'', inputType: '', options: [] },
          conditionClause: '',
          conditionValue: { value: '', type: '' },
        }
      }],
      stageCondition: this.stage_rule_condition.find((operator: any) => operator.name === 'For All'),
      logicCondition: this.stage_condition_operators.find((operator: any) => operator.name === "All"),
      logicOperator: [],
      displayAction: true,
      displayElseAction: false,
      actionsList: [{
        actions: this.stage_rule_action_options, template: [], values: {
          actionName: '',
          actionTemplate: '',
          actionTemplateContent: '',
          actionFormDetails: {},
        }
      }],
      elseActionsList: [{
        actions: this.stage_rule_action_options, template: [], values: {
          actionName: '',
          actionTemplate: '',
          actionTemplateContent: '',
          actionFormDetails: {},
        }
      }]
    };
    this.stage_rules.push(newRule);
    this.openRuleDialog(this.stage_rules.length - 1, 'Add Rule');
  };
  cancelRuleSet(stage_rule: any, rule_index: number) {
    if (stage_rule.id == null) {
      // This was a new rule that hasn't been saved yet; remove it from the list
      this.stage_rules.splice(rule_index, 1);
    } else if (stage_rule.originalCopy) {
      // Restore the original rule from the saved copy
      const original = stage_rule.originalCopy;
      for (const prop in original) {
        if (original.hasOwnProperty(prop)) {
          stage_rule[prop] = JSON.parse(JSON.stringify(original[prop]));
        }
      }
      delete stage_rule.originalCopy;
      stage_rule.isShowSummary = true;
    } else {
      // No original copy exists; just switch back to summary view
      stage_rule.isShowSummary = true;
    }
  }
  editRule(stage_rule: any) {
    // Save a deep copy of the rule
    stage_rule.originalCopy = JSON.parse(JSON.stringify(stage_rule));
    stage_rule.isShowSummary = false;
    const allActions = [
      ...(stage_rule.actionsList || []),
      ...(stage_rule.elseActionsList || []),
    ];
    allActions.forEach((action: any) => {
      if (
        action.values?.actionName?.name === 'Send Document Form' &&
        action.values?.actionFormDetails?.documentation_poc_role
      ) {
        const roleName = action.values.actionFormDetails.documentation_poc_role;
        const matchedRole = this.ruleActionFormData.roles?.find(
          (r: any) => r.name === roleName
        );
        if (matchedRole) {
          action.values.actionFormDetails.documentation_poc_role_id = matchedRole.id;
          this.getOwnerDetailsForRule(String(matchedRole.id));
        }
      }
    });
    const ruleIndex = this.stage_rules.indexOf(stage_rule);
    this.openRuleDialog(ruleIndex, 'Edit Rule');
  }

  openRuleDialog(index: number, title: string) {
    this.currentRuleIndex = index;
    this.ruleDialogTitle = title;
    this.showRuleDialog = true;
  }

  getAvailableTriggers(): any[] {
    if (this.currentRuleIndex < 0) return this.stageTriggerOptions;
    const currentRule = this.stage_rules[this.currentRuleIndex];
    const currentTriggerId = currentRule?.trigger?.id;
    const usedTriggerIds = this.stage_rules
      .filter((_rule: any, index: number) => index !== this.currentRuleIndex)
      .filter((rule: any) => rule.trigger?.id)
      .map((rule: any) => rule.trigger.id);
    return this.stageTriggerOptions.filter((trigger: any) =>
      !usedTriggerIds.includes(trigger.id) || trigger.id === currentTriggerId
    );
  }

  getFilteredActions(actions: any[]): any[] {
    const triggerId = this.stage_rules[this.currentRuleIndex]?.trigger?.id;
    const blockedMap: Record<number, number> = { 15: 105, 30: 120, 45: 75 };
    const blockedActionId = blockedMap[triggerId];
    if (!blockedActionId) return actions;
    return actions.filter((a: any) => a.id !== blockedActionId);
  }

  closeRuleDialog() {
    if (this.currentRuleIndex >= 0 && this.stage_rules[this.currentRuleIndex]) {
      const stage_rule = this.stage_rules[this.currentRuleIndex];
      if (stage_rule.id == null) {
        this.stage_rules.splice(this.currentRuleIndex, 1);
      } else if (stage_rule.originalCopy) {
        const original = stage_rule.originalCopy;
        for (const prop in original) {
          if (original.hasOwnProperty(prop)) {
            stage_rule[prop] = JSON.parse(JSON.stringify(original[prop]));
          }
        }
        delete stage_rule.originalCopy;
        stage_rule.isShowSummary = true;
      } else {
        stage_rule.isShowSummary = true;
      }
    }
    this.showRuleDialog = false;
    this.currentRuleIndex = -1;
  }

  saveAndCloseDialog(ruleId: number | null, index: number) {
    this.saveWorkflow(ruleId, index);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getDisplayValue(condition: any): string {
    if (!condition || !condition.values || !condition.values.conditionValue) {
      return '';
    }
    const fieldName = condition.values.conditionSource?.label;
    const fieldValue = condition.values.conditionValue.value;
    
    if (!fieldName || !fieldValue) {
      return fieldValue || '';
    }
    const displayValue = this.fieldLookupService.getLookupValue(fieldName, fieldValue, this.eventId);    
    return displayValue || fieldValue;
  }

  institutionsPage: number = 1;
  hasMoreInstitutions: boolean = true;
  loadingInstitutions: boolean = false;
  institutionsSearchQuery: string = "";

  onInstitutionDropdownShow(event: any, options: any, condition: any) {
    if (!["pg_college_name", "ug_college_name", "diploma_college_name"].includes(condition.values.conditionSource?.label)) {
      return
    }

    setTimeout(() => {
      const dropdownPanels = document.querySelectorAll('.p-select-overlay .p-select-list-container');
      dropdownPanels.forEach(panel => {
        panel.addEventListener('scroll', (event) => {
          this.handleDropdownScroll(event, condition);
        });
      });
    }, 200);
  }

  onInstitutionDropdownHide(event: any, options: any, condition: any) {
    if (!["pg_college_name", "ug_college_name", "diploma_college_name"].includes(condition.values.conditionSource?.label)) {
      return
    }

    const dropdownPanels = document.querySelectorAll('.p-select-overlay .p-select-list-container');
    dropdownPanels.forEach(panel => {
      panel.removeEventListener('scroll', (event) => {
        this.handleDropdownScroll(event, condition);
      });
    });
  }

  handleDropdownScroll(event: any, options: any) {
    const element = event.target;
    const threshold = 100;

    if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
      if (this.hasMoreInstitutions && !this.loadingInstitutions) {
        setTimeout(() => {
          if (this.hasMoreInstitutions && !this.loadingInstitutions) {
            this.institutionsPage++;
            this.getInstitutions(options);
          }
        }, 300);
      }
    }
  }

  filterInstitute(event: MultiSelectFilterEvent, condition: any) {
    if (!["pg_college_name", "ug_college_name", "diploma_college_name"].includes(condition.values.conditionSource?.label)) {
      return
    }

    if (event.filter.length >= 2 || !event.filter.length) {
      this.instituteSearch$.next();
      this.institutionsSearchQuery = event.filter;
      this.hasMoreInstitutions = true;
      condition.values.conditionSource.options = [];
      this.institutionsPage = 1;
      this.getInstitutions(condition);
    }
  }

  getInstitutions(condition: any) {
    this.loadingInstitutions = true;
    const params: any = { page: this.institutionsPage, s: this.institutionsSearchQuery };
    if (!this.institutionsSearchQuery) {
      delete params.s;
    }

    this.formBuilderServices.getEventSpecificFormDetailsFastApi(this.eventId, { includeInstitutes: true }, params).pipe(takeUntil(this.instituteSearch$)).subscribe((res) => {
      const institutions = res.body.institutes;
      let items: any[] = institutions.items || [];

      if (items) {
        if (items.length) {
          items = items.filter((item: any) => item.name?.toLowerCase() !== "others" && item.state?.toLowerCase() !== "others" && item.city?.toLowerCase() !== "others")
          const updatedItems = this.formBuilderServices.mapFieldOptions('institute', items, ['name', 'city', 'state'], ['name', 'city', 'state'])
          condition.values.conditionSource.options = [...condition.values.conditionSource.options, ...updatedItems];
        }

        if (items.length < institutions.size) {
          this.hasMoreInstitutions = false;
        }
      } else {
        this.hasMoreInstitutions = false;
      }

      this.loadingInstitutions = false;
    }, (err) => {
      this.loadingInstitutions = false;
      this.hasMoreInstitutions = true;
    })
  }
  
}
